export default {
  data() {
    return {
      created: false,
      updated: false,
    }
  },
  methods: {
    getTimeDiff(prop) {
      var time = Date.parse(this.getObjectPath(prop, this[this.prefix]))

      time = new Date(time)
      var now = new Date()
      var diffInSeconds = (now.getTime() - time.getTime()) / 1000
      return diffInSeconds
    }
  },
  mounted() {
    var diffCreated = this.getTimeDiff('createdAt')
    if (diffCreated <= 180 && diffCreated >= 0) this.created = true;
    if (this.$route.name == 'docket') {
      var diffDocketUpdated = this.getTimeDiff('docket.updatedAt')
      if (diffDocketUpdated <= 180 && diffDocketUpdated >= 0) this.updated = true;
    } else {
      var diffUpdated = this.getTimeDiff('updatedAt')
      if (diffUpdated <= 180 && diffUpdated >= 0) this.updated = true;
    }

    // if (this[this.prefix].new) {
    //     //console.log('rate was new');
    //     this.created = true;
    //     setTimeout(() => {
    //         this.created = false;
    //     }, 20000);


    this.$watch(`${this.prefix}.updated`, function (val) {
      if (val) {
        this.updated = true;
        setTimeout(() => {
          this.updated = false;
        }, 20000);
      }
    })
  },
}